var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_174855",
    clipPath: "url(#clip0_5191_13299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5524 0H7.44764C3.34099 0 0 3.34099 0 7.44764V17.5524C0 21.659 3.34099 25 7.44764 25H17.5524C21.659 25 25 21.659 25 17.5524V7.44764C25 3.34099 21.659 0 17.5524 0ZM22.485 17.5524C22.485 20.2766 20.2766 22.485 17.5524 22.485H7.44764C4.72344 22.485 2.515 20.2766 2.515 17.5524V7.44764C2.515 4.72339 4.72344 2.515 7.44764 2.515H17.5524C20.2766 2.515 22.485 4.72339 22.485 7.44764V17.5524Z",
    fill: "url(#paint0_linear_5191_13299)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.4991 6.03418C8.9338 6.03418 6.0332 8.93477 6.0332 12.5C6.0332 16.0653 8.9338 18.9659 12.4991 18.9659C16.0644 18.9659 18.965 16.0653 18.965 12.5C18.965 8.93473 16.0644 6.03418 12.4991 6.03418ZM12.4991 16.451C10.3171 16.451 8.5482 14.6821 8.5482 12.5001C8.5482 10.318 10.3171 8.54918 12.4991 8.54918C14.6811 8.54918 16.45 10.318 16.45 12.5001C16.45 14.6821 14.6811 16.451 12.4991 16.451Z",
    fill: "url(#paint1_linear_5191_13299)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.979 7.63192C19.8347 7.63192 20.5284 6.93825 20.5284 6.08256C20.5284 5.22688 19.8347 4.5332 18.979 4.5332C18.1234 4.5332 17.4297 5.22688 17.4297 6.08256C17.4297 6.93825 18.1234 7.63192 18.979 7.63192Z",
    fill: "url(#paint2_linear_5191_13299)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5191_13299",
    x1: 12.5,
    y1: 24.9272,
    x2: 12.5,
    y2: 0.194179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5191_13299",
    x1: 12.4991,
    y1: 24.9273,
    x2: 12.4991,
    y2: 0.19425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5191_13299",
    x1: 18.979,
    y1: 24.9271,
    x2: 18.979,
    y2: 0.194088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5191_13299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.f9eee3d00a0c592c90fc8c0787679fc6.svg";
export { ForwardRef as ReactComponent };